

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
  const b2bModalWrapperEl = event.currentTarget.closest('.subindustries_navigation_popup__wrapper');
    if(b2bModalWrapperEl) {
      const collapsible_contentWrapperEl = event.currentTarget.closest('.collapsible-content');
      const prevActiveAccordion = collapsible_contentWrapperEl.querySelector('details[open]');
      if(prevActiveAccordion) {
        const prevActiveSummaryEl = prevActiveAccordion.querySelector('summary');

        if(event.currentTarget.id != prevActiveSummaryEl.id ) {
          prevActiveAccordion.removeAttribute('open');
          prevActiveSummaryEl.setAttribute('aria-expanded','false');
        }
      }
    }
       event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('input', { bubbles: true });
      this.additional_changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('input', this.onInputChange.bind(this));
    this.input.addEventListener('keydown', function(e) {
       if (e.keyCode == 13) {
         e.preventDefault();
         return false;
    }
    });
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();

  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
       if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
      this.input.dispatchEvent(this.additional_changeEvent);
    }
  }

  validateQtyRules() {

    
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }


    const sectionId = this.getAttribute('data-section-id');
    const priceEl = document.querySelector('#price-'+sectionId);
 
    if(priceEl) {
      let currentVariant =  null;
      
      if(document.querySelector('variant-radios')) {
      currentVariant = document.querySelector('variant-radios').currentVariant;
      } else if(document.querySelector('variant-selects')) {
        currentVariant =   document.querySelector('variant-selects').currentVariant;
      }

      if(currentVariant == null) {
        const product_dataEl = document.querySelector('#product_data_'+sectionId);
        if(product_dataEl) {
       currentVariant = JSON.parse(product_dataEl.textContent);
        }
      }
        

        if(currentVariant) {
          const product_price_itemEl = priceEl.querySelector('.price-item.price-item--regular');
          if(product_price_itemEl) {

            let currentVariant_price = currentVariant.price;
            let qtyVal = this.input.value * 1;

            if(typeof metadata == 'object') {
            Object.keys(metadata).forEach(key => {
          if (key == currentVariant.id) {
            for(let x=0;x <  metadata[key].length;x++) {
              const el = metadata[key][x];
              const min_range = el.range.split('-')[0] * 1;
              const max_range = el.range.split('-')[1] * 1;
    
              if(qtyVal >= min_range && qtyVal <= max_range ) {
                  currentVariant_price = el.price * 100;
                break;
              }
            }  
          }
        });
            }
           
            product_price_itemEl.innerHTML = formatMoney((currentVariant_price * qtyVal), window.moneyFormat);
          }
        }
    }
    
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {

                        const activeSearchForm = document.querySelector('.header-predictive-search-wrapper.active_form');
        if(activeSearchForm) {
          activeSearchForm.classList.remove('active_form');
          document.querySelector('predictive-search').closeResults(true);
        }
        
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {

                      const activeSearchForm = document.querySelector('.header-predictive-search-wrapper.active_form');
        if(activeSearchForm) {
          activeSearchForm.classList.remove('active_form');
          document.querySelector('predictive-search').closeResults(true);
        }
      
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const currentTarget = event.currentTarget;
    if(currentTarget.closest('.custom_redirect_popover_wrapper')) {
      
    } else {
      const detailsElement = currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {

                      const activeSearchForm = document.querySelector('.header-predictive-search-wrapper.active_form');
        if(activeSearchForm) {
          activeSearchForm.classList.remove('active_form');
          document.querySelector('predictive-search').closeResults(true);
        }
      
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
   
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {

    if(this.slider.classList.contains('thumbnail-list')) {
      if(window.innerWidth >= 990) {

          this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;
        
      const lastVisibleSlide = this.slider.offsetHeight + this.slider.scrollTop - offset;
    return (element.offsetTop + element.clientHeight) <= lastVisibleSlide && element.offsetTop >= this.slider.offsetTop;
        
      } else {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
      }
    } else {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;

     if(this.slider.classList.contains('thumbnail-list')) {
      if(window.innerWidth >= 990) {
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollTop + (step * this.sliderItemOffset) : this.slider.scrollTop - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      top: this.slideScrollPosition
    });
        
      } else {
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
      }
    } else {
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
    }
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    // this.dispatchEvent(new Event('change', { bubbles: true }));

     this.updateOptions();
    this.updateMasterId();

  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
 
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.toggleAddButton(true, '', false);
    

    if (!this.currentVariant) {
    
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {    
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });

    const productInfoWrapperEl = this.closest('product-info');
    if(productInfoWrapperEl) {
      if(this.currentVariant.available) {
       productInfoWrapperEl.classList.add('in-stock-variant-wrapper');
      } else {
      productInfoWrapperEl.classList.remove('in-stock-variant-wrapper');
      }
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));


    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));

            const variant_tabs_tableArr = document.querySelectorAll('.variant_tabs_table');
      if(variant_tabs_tableArr.length)   {
        for(const variant_tabs_table of variant_tabs_tableArr) {
          const table_variantId = variant_tabs_table.getAttribute('data-variant-id') * 1;
          if(this.currentVariant.id == table_variantId) {
            variant_tabs_table.classList.add('active');
          } else {
          variant_tabs_table.classList.remove('active');
          }
        }
      }
      
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);


          const discount_min7Destination = document.getElementById(`min7_prop_${this.dataset.section}`);
          const discount_min10Destination = document.getElementById(`min10_prop_${this.dataset.section}`);
          const discount_min20Destination = document.getElementById(`min20_prop_${this.dataset.section}`);

          const discount_min7Source = html.getElementById(`min7_prop_${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const discount_min10Source = html.getElementById(`min10_prop_${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const discount_min20Source = html.getElementById(`min20_prop_${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        if (discount_min7Source && discount_min7Destination) {
          discount_min7Destination.innerHTML = discount_min7Source.innerHTML;
        }
        if (discount_min10Source && discount_min10Destination) {
          discount_min10Destination.innerHTML = discount_min10Source.innerHTML;
        }
       if (discount_min20Source && discount_min20Destination) {
          discount_min20Destination.innerHTML = discount_min20Source.innerHTML;
        }

        
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
       
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});

        if(window.Klarna) {
        window.Klarna.OnsiteMessaging.refresh();
        }

      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {

   
    let preOrderVariant = false;
    if(this.currentVariant) {
    const variantStock = variantsStock[this.currentVariant.id];
    if(variantStock) {
      if(variantStock.inventory_quantity <= 0 && variantStock.inventory_policy == "continue" && variantStock.inventory_management == "shopify") {
        preOrderVariant = true;
      }
    }
    this.preOrderVariant = preOrderVariant;
    }
    
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    
    if (!productForm) return;

    const preOrderInput = productForm.querySelector('#preOrderInput');
    if(preOrderInput) {
      if(this.preOrderVariant) {
        preOrderInput.setAttribute('name','properties[Type]');
      } else {
        preOrderInput.removeAttribute('name');
      }
    }
    
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');

      if(this.preOrderVariant) {
         addButtonText.textContent = window.variantStrings.pre_order;
      } else {
      addButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {

    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {

    let option_selected_valueEl = fieldset.querySelector('.option_selected_value');

        if(fieldset.querySelector("input:checked")) {
    const checkedValue = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      
      if(option_selected_valueEl) {
        option_selected_valueEl.innerHTML = checkedValue;
      }
      
      return checkedValue;
        }
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class ProductUpsell extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-upsell');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          const _this = this;
                var count = 0;
                var total = 0;

                if ($('#inline_upsell').length > 0) { 
                    $('.product-upsell .item').each(function() {
                        var product_type = $('.product-upsell').data('product-type');

                     if( count == 0) {
                          count++;
                 
                            total += $(this).data('price');
                            $(this).clone().appendTo($('#inline_upsell .inner-wrapper'));
                            $(this).find('.item-action').remove(); 
                     } else if( $(this).data('product-type') != product_type && count < 3) {
                     
                            count++;
                            if(count > 1) {
                                $('<div class="plus"><span>+</span></div>').appendTo($('#inline_upsell .inner-wrapper'));
                            }
                            total += $(this).data('price');
                            $(this).clone().appendTo($('#inline_upsell .inner-wrapper'));
                            $(this).find('.item-action').remove(); 
                        }
                    });

                    if(count > 0 ) {

                        $('<div class="equals"><span>=</span></div>').appendTo($('#inline_upsell .inner-wrapper'));
                        $('.product-upsell .col-total').appendTo($('#inline_upsell .inner-wrapper'));
                        $('#inline_upsell .col-total .total span').text( formatMoney(total, window.moneyFormat) );
                        $("#inline_upsell").slideDown(); 
                        $(".catalog-item__info .button-extras").css("display", "flex");
                        $('#additional_products').on('click', function() {
                            $("html,body").animate({
                                scrollTop: $("#inline_upsell").offset().top
                            });
                        });

                        $('#inline_upsell .item-action input').on('change', function() {
                            total = 0;
                            if(this.checked) {
                                $(this).next('label').text('Added');   
                            }
                            else {
                                $(this).next('label').text('Add');
                            }
    
                            if($("#inline_upsell .item-action input:checked").length == 0) {
                                $('#inline_upsell #upsell_addtocart').text('Make a Selection');      
                            }
                            else {
                                $('#inline_upsell #upsell_addtocart').text('Add to cart');
                            }
    
                            $( "#inline_upsell .item-action input:checked").each(function(i, e) {
                                total = total + $(this).data("price");       
                            });
    
                            $('#inline_upsell .col-total .total span').text(formatMoney(total, window.moneyFormat) );
                        });

                       $('#inline_upsell #upsell_addtocart').on('click', function() {

                          let self = this;
                          
                            if($( "#inline_upsell .item-action input:checked").length == 0) {
                                return;    
                            }
    
                            $("#ajax-overlay").show();
                            $("#ajax-progress").show();

                          var items = [];
                          
                            $( "#inline_upsell .item-action input:checked").each(function(i, e) {
                                var variant_id = $(this).data("variant-id");
                                let discount_7 = $(this).data("min_7");
                                let discount_10 = $(this).data("min_10");
                                let discount_20 = $(this).data("min_20");

                                if (variant_id) {
                                    items.push({
                                        id: variant_id,
                                        quantity: 1,
                                        properties: {
                                            '_discount_min7': discount_7,
                                            '_discount_min10': discount_10,
                                            '_discount_min20': discount_20
                                        }
                                    });
                                }
                            });  

                          if(items.length) {

                               let formData = {
                              'items': items
                              };
                          
                            
                              fetch(`${routes.cart_add_url}`, {
                                method: 'POST',
                                headers: {
                                'Content-Type': 'application/json'
                              },
                              body: JSON.stringify(formData)
                              }).then(function (response) {
                              if (response.ok) {
                                  $("#ajax-overlay").hide();
                                  $("#ajax-progress").hide();
                                  document.location.href = '/cart';
                              } else {
                                response.json().then(function (content) {
                                var errorMessageElement = document.createElement('span');
                                  errorMessageElement.className = 'Alert Alert--error';
                                  errorMessageElement.innerHTML = content['description'];
        
                                  self.insertAdjacentElement('afterend', errorMessageElement);
                                  
                                  setTimeout(function () {
                                    errorMessageElement.remove();
                                  }, 2500);
                                  });
                              }
                              });
                            
                          }
          
                        });
            $('body').addClass('show_upsell_anchor_btn');
                       
                    } else {
                      $('#inline_upsell').remove();
                       $('body').removeClass('show_upsell_anchor_btn');
                    }

                }
                var popup_created = 0;
                if ($('#popup_upsell').length > 0) {  
                    count = 0;
                    $('.product-upsell .item').each(function() {
                        var product_type = $('.product-upsell').data('product-type');
                         if( count == 0) {
                           count++;
                            $(this).clone().appendTo($('#popup_upsell .inner-wrapper'));
                         } else if( $(this).data('product-type') != product_type && count < 3) {
                            count++;
                            $(this).clone().appendTo($('#popup_upsell .inner-wrapper'));
                        }
                    });

                    if(count > 0 ) {

                        $('.upsell-popup-trigger').on('click', function() {
                            $.fancybox.open({
                                src  : '#popup_upsell',
                                type : 'inline',
                                opts : {
                                    afterShow : function( instance, current ) {
                                        if(popup_created !=1 ){
                                            $(".fancybox-content .popup_addtocart .ajax-add-cart").on("click", function(e) {
                                                e.preventDefault();
                                                var item_form = this.closest('.popup-form');
                                                if (item_form) {
                                                    var item_elem = $(this).parents('.item');
                                                    item_elem.find('.ajax-progress').css('display', 'flex');
                                                      const formData = new FormData(item_form);
                                                        const cartEL = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                                                    if(cartEL) {
                                                    formData.append('sections', cartEL.getSectionsToRender().map((section) => section.id));
                                                    formData.append('sections_url', window.location.pathname);
                                                    cartEL.setActiveElement(document.activeElement);
                                                  }
                                    
                                                    const config = fetchConfig('javascript');
                                                        config.headers['X-Requested-With'] = 'XMLHttpRequest';
                                                        delete config.headers['Content-Type'];
                                                           config.body = formData;

                                                        fetch(`${routes.cart_add_url}`, config)
                                                          .then((response) => response.json())
                                                          .then((response) => {
                                                           
                                                                if(cartEL) {
                                                                  cartEL.renderContents(response);
                                                                }
                                                          item_elem.find('.ajax-progress').css('display', 'none');
                                                          item_elem.addClass('added');
                                                          item_elem.find('.popup_addtocart .btn').html('<span>Added to cart</span>');

                                                          if (typeof gtag === 'function') {
                                                              if(t.variant_options[0] != "Default Title" ){
                                                                  var prodId = t.product_id + "-" + t.id;
                                                              }else{
                                                                  var prodId = t.product_id;
                                                              }
                                                              gtag('event', 'add_to_cart', {
                                                                  'value': t.price * 0.01,
                                                                  'items': [
                                                                      {
                                                                          'id': prodId,
                                                                          'google_business_vertical': 'retail'
                                                                      }
                                                                  ]
                                                              });
                                                          }
                                                       
                                                          })
                                                          .catch((e) => {
                                                            console.error(e);
                                                             $.fancybox.open(r);
                                                          })
                                                }
                                            });
                                            $('#popup_upsell .btn-continue').on('click', function(e) {
                                                e.preventDefault();
                                                $.fancybox.close();
                                            });
                                        }

                                    },
                                    afterClose : function() {
                                        popup_created = 1;
                                    }
                                }
                            });  
                        });

                        $('.product-form form.form').on('submit', function(e) {
                         
                            e.preventDefault();
                            $("#ajax-overlay").show();
                            $("#ajax-progress").show();
                            $.ajax({
                                type: 'POST', 
                                url: `${routes.cart_add_url}`,
                                dataType: 'json', 
                                data: $('.product-form form.form').serialize()
                            })
                            .done(function(t) {

                                $("#ajax-overlay").hide();

                                $("#ajax-progress").hide();

                                $('.upsell-popup-trigger').trigger('click'); 

                            })
                            .fail(function(t, r) {

                                alert( "error" );

                                Shopify.onError(t, r);  

                            });
                        });
                    }
                }
         

    
        })
        .catch(e => {
          console.error(e);
        });
    }
}

customElements.define('product-upsell', ProductUpsell);


class Brands extends HTMLElement {
  constructor() {
    super();

    const $sectionSliderContainer = $(this).find('.swiper-container--top-brands');
    const sectionId = this.getAttribute('data-section-id');
    
    if($sectionSliderContainer.length) {
    this.swiperTopBrands = new Swiper(".swiper-container--top-brands", {
    slidesPerView: 6,
    slidesPerGroup: 6,
    autoplay: {
    delay: 3000
    },
    loop: true,
    navigation: {
    nextEl: ".swiper-button-next--top-brands-"+sectionId,
    prevEl: ".swiper-button-prev--top-brands-"+sectionId
    },
    breakpoints: {
    767: {
    slidesPerView: 3,
    slidesPerGroup: 3
    },
    1479: {
    slidesPerView: 5,
    slidesPerGroup: 5
    }
    }
    });
    }
}
 
  connectedCallback() {
    
  }
}

customElements.define('brands-slider', Brands);

class Featured_slider extends HTMLElement {
  constructor() {
    super();

    const $sectionSliderContainer = $(this).find('.featured-blocks-slider');
    const sectionId = this.getAttribute('data-section-id');
    if($sectionSliderContainer.length) {
      $sectionSliderContainer.slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        adaptiveHeight: true,
        nextArrow: '<div class="slick-button-next" aria-label="Next">' + window.assets.icon_right + '</div>',
        prevArrow: '<div class="slick-button-prev" aria-label="Previous">' + window.assets.icon_left + '</div>',
        responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 1
            }
          }
        ]
  });
    }

}
 
  connectedCallback() {
    
  }
}

customElements.define('featured-blocks-slider', Featured_slider);

class Featured_media_slider extends HTMLElement {
  constructor() {
    super();

    const $sectionSliderContainer = $(this).find('.media-blocks--slider');
    const sectionId = this.getAttribute('data-section-id');
    const slidesPerRow = this.getAttribute('data-slides_per_row') * 1 || 4;
    const infinity_loopFlag = !!this.getAttribute('data-infinite_loop') || false;
    const sliderAutoplay = !!this.getAttribute('data-autoplay') || false; 

    const sliderSpeed =  this.getAttribute('data-speed') * 1000 || 3000; 
    let tabletSlidesPerRow = 3;
    if(slidesPerRow < 3) {
      tabletSlidesPerRow = slidesPerRow;
    }
   
    if($sectionSliderContainer.length) {
      $sectionSliderContainer.slick({
        infinite: infinity_loopFlag,
        slidesToShow: slidesPerRow,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        autoplay: sliderAutoplay,
        autoplaySpeed: sliderSpeed,
        nextArrow: '<div class="slick-button-next" aria-label="Next">' + window.assets.icon_right + '</div>',
        prevArrow: '<div class="slick-button-prev" aria-label="Previous">' + window.assets.icon_left + '</div>',
        responsive: [
           {
            breakpoint: 1200,
            settings: {
              slidesToShow: tabletSlidesPerRow
            }
          },
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 1
            }
          }
        ]
  });
    }

}
 
  connectedCallback() {
    
  }
}

customElements.define('custom-media-blocks--slider', Featured_media_slider);
class FeaturedSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const _this = this;
    this.columns_mobile = this.getAttribute('data-columns_mobile');
    this.columns_desktop = this.getAttribute('data-columns_desktop');
    this.sliderEl = this.querySelector('.featured-slider-wrapper');
    this.slidesArr = this.sliderEl.querySelectorAll('.featured-slide');
    this.sliderAutoplay = !!this.getAttribute('data-autoplay_slider') || false; 
    this.sliderSpeed =  this.getAttribute('data-slider_speed') * 1 || 3000; 
    
    this.slider_btn_prev = this.querySelector('.slider-button--prev');
    this.slider_btn_next = this.querySelector('.slider-button--next');

    if(this.slidesArr.length > 1) {
    if(this.closest('.featured_articles_slider_section') ) {
  
    let initSlider = false;
    function responseSectionSlider() {
  
        var windowWidth = window.innerWidth;
        if(windowWidth <= 749) {
          if(initSlider) {
            initSlider = false;
            $(_this.sliderEl).slick('unslick');          
          }
        } else {
          if(initSlider == false) {
            initSlider = true;

             _this.options = {
                slidesToShow: _this.columns_desktop,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,
                prevArrow: _this.slider_btn_prev,
                nextArrow: _this.slider_btn_next
              };
              $(_this.sliderEl).slick(_this.options);  
             
          }
        }
    }
    responseSectionSlider();
           window.addEventListener("resize", debounce(function(e) {
             responseSectionSlider();
         },100));

    } else {
        
      this.options = {
    slidesToShow: _this.columns_desktop,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    autoplay: _this.sliderAutoplay,
   autoplaySpeed: _this.sliderSpeed,
    prevArrow: _this.slider_btn_prev,
    nextArrow: _this.slider_btn_next,
    responsive: [
      {
            breakpoint: 767,
            settings: {
              slidesToShow: _this.columns_mobile
            }
        }
    ]
    };
 
      $(_this.sliderEl).slick(_this.options);
    }
    }
  }

}
customElements.define('featured-slider', FeaturedSlider);

class SlickSliderWithProgress extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const _this = this;

    const slider = $(_this).find('.compare-slick');
    const progressBar = $(_this).find('.compare-progress');
    slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var calc = ((nextSlide) / (slick.slideCount - 1)) * 100;
    progressBar
        .css('background-size', calc + '% 100%')
        .attr('aria-valuenow', calc);
});

    slider.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
     nextArrow: '<button class="slick-next slick-arrow"  aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="287px" height="500px" viewBox="0 0 287 500" version="1.1" class="icon icon--wide icon-chevron-down">\n' +
        '  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n' +
        '    <g id="Home_PageV1.0-(New-Header-2)" transform="translate(-842.000000, -38.000000)" fill="#231F20" fill-rule="nonzero">\n' +
        '      <g id="Chevron_Right" transform="translate(985.500000, 288.000000) rotate(-90.000000) translate(-985.500000, -288.000000) translate(736.000000, 145.000000)">\n' +
        '        <path d="M-2.08404451e-05,36 C-0.00506788343,21.8412166 8.52093753,9.07408275 21.6011171,3.65374389 C34.6812967,-1.76659497 49.7387394,1.22771594 59.75,11.24 L249.49,200.99 L439.23,11.24 C448.072323,2.39767621 460.960291,-1.05564449 473.039129,2.18087043 C485.117968,5.41738535 494.552615,14.8520323 497.78913,26.9308709 C501.025644,39.0097095 497.572324,51.8976767 488.73,60.74 L274.24,275.24 C267.676124,281.804546 258.773196,285.492525 249.49,285.492525 C240.206804,285.492525 231.303876,281.804546 224.74,275.24 L10.25,60.74 C3.67855857,54.1850295 -0.0101375586,45.2817766 -2.08404451e-05,36 Z" id="Path"/>\n' +
        '      </g>\n' +
        '    </g>\n' +
        '  </g>\n' +
        '</svg></button>',
    prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="287px" height="500px" viewBox="0 0 287 500" version="1.1" class="icon icon--wide icon-chevron-down"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Home_PageV1.0-(New-Header-2)" transform="translate(-842.000000, -38.000000)" fill="#231F20" fill-rule="nonzero"><g id="Chevron_Left"transform="translate(985.500000, 288.000000) scale(-1, 1) rotate(-90.000000) translate(-985.500000, -288.000000) translate(736.000000, 145.000000)"><path d="M-2.08404451e-05,36 C-0.00506788343,21.8412166 8.52093753,9.07408275 21.6011171,3.65374389 C34.6812967,-1.76659497 49.7387394,1.22771594 59.75,11.24 L249.49,200.99 L439.23,11.24 C448.072323,2.39767621 460.960291,-1.05564449 473.039129,2.18087043 C485.117968,5.41738535 494.552615,14.8520323 497.78913,26.9308709 C501.025644,39.0097095 497.572324,51.8976767 488.73,60.74 L274.24,275.24 C267.676124,281.804546 258.773196,285.492525 249.49,285.492525 C240.206804,285.492525 231.303876,281.804546 224.74,275.24 L10.25,60.74 C3.67855857,54.1850295 -0.0101375586,45.2817766 -2.08404451e-05,36 Z"id="Path"/> </g> </g> </g> </svg></button>',
  responsive: [
        {
            breakpoint: 1025,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                arrows: false

            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                variableWidth: true,
               arrows: false                   
            }
        },
    ]

})
  }

}
customElements.define('slider-with-progress-bar', SlickSliderWithProgress);

class TabsAnimationSlider extends HTMLElement {
  constructor() {
    super();
     this.pausedSlider = false;
     this.animationSpeed = this.getAttribute('data-animation_speed') * 1000;
      this.animationSpeed += 500;
   
    
     this.slidesArr = this.querySelectorAll('.tabs_animation_slider_nav__item');

     function RecurringTimer(callback, delay) {
    var timerId, start, remaining = delay;

    this.stop = function () {
          window.clearTimeout(timerId);
       };
    this.pause = function() {
        window.clearTimeout(timerId);
        remaining -= new Date() - start;
    };

    var resume = function() {
        start = new Date();
        timerId = window.setTimeout(function() {
            remaining = delay;
            resume();
            callback();
        }, remaining);
    };
    
    this.resume = resume;

    this.resume();
}
     this.RecurringTimer = RecurringTimer;

  }
  connectedCallback() {
    this.activeIndex = 0;    
    if(this.slidesArr.length > 1) {
      this.activateAnimate();
     for(const slide_nav of this.slidesArr) {
       slide_nav.addEventListener('click',this.changeActiveSlide.bind(this));
     }
    }
        
  }
  activetedSlide(activeSlide) {
    const _this = this; 
    const block_id = activeSlide.getAttribute('data-block-id'); 
    const tabs_animation_slide_El = document.querySelector('#'+block_id);
    
      if(tabs_animation_slide_El)     {
        tabs_animation_slide_El.classList.add('active');
      }
     activeSlide.classList.add('active'); 

    if(window.innerWidth <= 767) {
      const activeNavItem_offsetLeft = activeSlide.offsetLeft;
      const tabs_animation_slider_navParentEl = activeSlide.closest('.tabs_animation_slider_nav');
      if(tabs_animation_slider_navParentEl) {

        tabs_animation_slider_navParentEl.scrollTo({
        top: 0,
        left: (activeNavItem_offsetLeft - 15),
        behavior: 'smooth'
      });
      }
    }
  }
 
  activateAnimate() {
    const _this = this;
    this.timer =  _this.RecurringTimer(function() { 

        const prevActiveSlide = _this.querySelector('.tabs_animation_slider_nav__item.active');
        if(prevActiveSlide) {
          const prev_block_id = prevActiveSlide.getAttribute('data-block-id'); 
          const prev_tabs_animation_slideEl = document.querySelector('#'+prev_block_id);
               
          prevActiveSlide.classList.remove('active');
            _this.activeIndex = _this.activeIndex + 1;
          if(prev_tabs_animation_slideEl) {
            prev_tabs_animation_slideEl.classList.remove('active');
          }   

          let activeSlide = _this.slidesArr[_this.activeIndex];
          if(!activeSlide) {
            _this.activeIndex = 0;
            activeSlide = _this.slidesArr[_this.activeIndex];
          }
            
          if(activeSlide) {
            _this.activetedSlide(activeSlide);       
          }        
        }             
    }, _this.animationSpeed);
  }

  stopAnimate() {
    const _this = this;
    this.pausedSlider = true;
     this.stop();
    _this.classList.add('stopAnimate');
  }
  
  getSlideIndex(node) {
  var children = node.parentNode.childNodes;
    var num = 0;
    for (var i=0; i<children.length; i++) {
         if (children[i]==node) return num;
         if (children[i].nodeType==1) num++;
    }
    return -1;
  }
  
  changeActiveSlide(e) {
    e.preventDefault();
    const _this = this;
    let el = e.target;
    
    this.stopAnimate();
    if(!el.classList.contains('tabs_animation_slider_nav__item')) {
      el = el.closest('.tabs_animation_slider_nav__item');
    }
    const prevActiveSlide = this.querySelector('.tabs_animation_slider_nav__item.active');
    if(prevActiveSlide) {
         const prev_block_id = prevActiveSlide.getAttribute('data-block-id'); 
        const prev_tabs_animation_slide_El = document.querySelector('#'+prev_block_id);
           
         prevActiveSlide.classList.remove('active');
       if(prev_tabs_animation_slide_El) {
          prev_tabs_animation_slide_El.classList.remove('active');
        }
      _this.activetedSlide(el);
      _this.activeIndex = _this.getSlideIndex(el);   
      }    
   
  }
}

customElements.define('tabs-animation-slider', TabsAnimationSlider);